import { render, staticRenderFns } from "./TasklistLoadProgress.vue?vue&type=template&id=65764cf6"
import script from "./TasklistLoadProgress.vue?vue&type=script&lang=js"
export * from "./TasklistLoadProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports